import { render, staticRenderFns } from "./restaurantAdmimForm.vue?vue&type=template&id=764ea8bd&"
import script from "./restaurantAdmimForm.vue?vue&type=script&lang=js&"
export * from "./restaurantAdmimForm.vue?vue&type=script&lang=js&"
import style0 from "./restaurantAdmimForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports